import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Ohio = () => {
  return (
    <StatePropertyTaxPage
      stateName="Ohio"
      processDescription="Property owners may file complaints with the county board of revision within 30 days of receiving notice of valuation and taxation. Appeals should include evidence supporting the property owner's claimed value. Further appeals may be made to the state board of tax appeals."
      noticeOfValueMailed="March"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in March following the county's triennial reappraisal or annual updates."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Ohio assesses property as of January 1 each year, with counties conducting triennial reappraisals. This assessment date ensures consistent timing across all Ohio counties."
      deadlineExplanation="Property owners have 30 days from receiving the notice to file complaints with the county board of revision. This deadline is typically in April."
    />
  );
};

export default Ohio;